import { Row } from "./Row";

interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const ProductPartners = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title="Product Partners"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Medcursor works together and has a business partnership with various
        product partners who manufacture Medcursor -compatible smart devices.
        Product partners include Medcursor and clevast. Medcursor’s mobile
        applications control and manage these smart devices. These product
        partners are affiliates of Medcursor, and as such, they collaborate with
        Medcursor. In specific, Medcursor manages online accounts or the mobile
        applications allowing users to div and manage the personal information
        collected from product partners’ smart devices. Product partners have
        arranged for Medcursor to collect and maintain such personal information,
        and users can div and manage the personal information from their mobile
        devices using a Medcursor mobile application. Please refer to the product
        partners’ privacy policies if you have questions about how they collect,
        use, disclose, protect, and manage your personal information in
        connection with your purchase of products from them. Medcursor has agreed
        with its product partners to meet the standards of their privacy
        policies for the personal information we collect and maintain in
        connection with the use of product partners’ smart devices.
        <div className="mt-4">
          Although Medcursor’s mobile application allows users to purchase
          products, Medcursor also works with retailers. For example, Medcursor has
          affiliate marketing relationships with retailers such as Amazon for
          the purchase of products listed on Medcursor’s website. They have their
          own privacy policies. Please refer to retailers’ privacy policies if
          you have questions about how they collect, use, disclose, protect, and
          manage your personal information.
        </div>
      </div>
    </Row>
  );
};
